export default __webpack_public_path__ + "static/media/bgDeskBlue.c9e6a54b.svg";